import React from "react";
import "../../App.css";
import SubStationMasterForm from "../SubStationMaster";

function SubStationMasterPage({ sessionObject }) {
  if (
    !sessionObject.sessionVariables["modules"].includes("sub_station_master")
  ) {
    return;
  }
  return (
    <div className="page-vehicle">
      <SubStationMasterForm sessionObject={sessionObject} />
    </div>
  );
}

export default SubStationMasterPage;